import { temAcesso } from '@/shared/auth/temAcesso'

const ContratosLAI = () => import('./relatorio-contrato-lai/RelatorioContratoLai.vue')
const ContratosIJ = () => import('./relatorio-contrato-ij/RelatorioContratoIj.vue')
const OrcamentoResultados = () => import('./relatorio-orcamento-resultados/RelatorioOrcamentoResultados.vue')

export default {
    path: 'dados-complementares',
    name: 'DadosComplementares',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('JUR-REL-08') || temAcesso('JUR-REL-09') || temAcesso('JUR-REL-10')) {
            next()
        }
    },
    children: [
        {
            path: 'contratos-lai',
            name: 'DadosComplementaresContratosLAI',
            component: ContratosLAI,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-08') || temAcesso('JUR-REL-09') || temAcesso('JUR-REL-10')) {
                    next()
                }
            }
        },
        {
            path: 'contratos-ij',
            name: 'DadosComplementaresContratosIJ',
            component: ContratosIJ,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-08') || temAcesso('JUR-REL-09') || temAcesso('JUR-REL-10')) {
                    next()
                }
            }
        },
        {
            path: 'orcamento-e-resultados',
            name: 'DadosComplementaresOrcamentoResultados',
            component: OrcamentoResultados,
            beforeEnter: (to, from, next) => {
                if (temAcesso('JUR-REL-08') || temAcesso('JUR-REL-09') || temAcesso('JUR-REL-10')) {
                    next()
                }
            }
        },
    ]
}